import { type Configuration } from '@azure/msal-browser'
const redirectUri = process.env.REACT_APP_APP_URL
const clientId: any = process.env.REACT_APP_APP_CLIENT_ID
const tenantId = process.env.REACT_APP_TENANT_ID
export const msalConfig: Configuration = {
    auth: {
        clientId,
        authority: 'https://login.microsoftonline.com/' + tenantId,
        clientCapabilities: ['CP1'],
        redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
}
export const loginRequest = {
    scopes: [`api://${clientId}/.default`],
}

export const DATA_DOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN || ''
export const DATA_DOG_APPLICATION_ID = process.env.REACT_APP_DATADOG_APPLICATION_ID || ''
